import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import Logo from "@/components/Logo";
import Button from "@/components/Button";
import { Field } from "@/components/Form";
import { Eyebrow, Headline } from "@/components/Editorial";
import { apiPost } from "@/lib/api";
import { toast } from "@/components/Toast";
import { C } from "@/lib/brand";

export default function ResetPassword() {
  const [search] = useSearchParams();
  const navigate = useNavigate();
  const token = search.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 8) {
      toast("Password must be at least 8 characters.", "error");
      return;
    }
    if (pw !== pw2) {
      toast("Passwords don't match.", "error");
      return;
    }
    setLoading(true);
    try {
      await apiPost("/consumer/auth/reset-password", { token, newPassword: pw }, { auth: false });
      toast("Password updated. Sign in with your new password.", "success");
      navigate("/sign-in");
    } catch (err) {
      toast(err.detail || "Reset failed — link may have expired.", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="reset-password-page" style={{ minHeight: "100vh", background: C.cream }}>
      <header style={{ background: C.ink, padding: "20px 24px" }}>
        <Link to="/sign-in"><Logo light size={22} /></Link>
      </header>
      <div style={{ display: "flex", justifyContent: "center", padding: 24 }}>
        <form onSubmit={submit} style={{ width: "100%", maxWidth: 460, background: C.pure, padding: "48px 36px", border: `1.5px solid ${C.warmGray3}`, marginTop: 40 }}>
          <Eyebrow>★ NEW PASSWORD</Eyebrow>
          <Headline before="SET A" italic="new one." size={56} className="mt-4" />
          <Field label="NEW PASSWORD" type="password" name="new-password" id="reset-pw" autoComplete="new-password" value={pw} onChange={setPw} testId="reset-pw-input" autoFocus />
          <Field label="CONFIRM PASSWORD" type="password" name="new-password" id="reset-pw2" autoComplete="new-password" value={pw2} onChange={setPw2} testId="reset-pw2-input" />
          <div style={{ marginTop: 28 }}>
            <Button type="submit" variant="primary" block testId="reset-submit-btn" disabled={loading || !token}>
              {loading ? "UPDATING…" : "UPDATE PASSWORD →"}
            </Button>
          </div>
          {!token && (
            <div style={{ marginTop: 16, fontSize: 13, color: C.coral }}>
              Missing reset token. Please use the link from your email.
            </div>
          )}
        </form>
      </div>
    </div>
  );
}
